import { Link } from "@tanstack/react-router";
import { Logo } from "./Logo";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";

export function SiteFooter() {
  return (
    <footer className="bg-navy-950 text-stone-100">
      <div className="container-elegant grid gap-12 py-20 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo variant="light" />
          <p className="mt-6 max-w-md text-sm leading-relaxed text-stone-100/60">
            Estudio Libertad E.A.E.S. · Consultores y Abogados. Práctica penal, procesal penal,
            civil, comercial, societaria, de familia, sucesoria, laboral, inmobiliaria, notarial,
            contencioso administrativa e indemnizatoria patrimonial en Asunción, Paraguay. Atención
            personal, técnica y absoluta confidencialidad.
          </p>
          <div className="mt-8 flex gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="flex h-10 w-10 items-center justify-center border border-stone-100/15 text-stone-100/70 transition-all hover:border-gold-500 hover:text-gold-500"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className="flex h-10 w-10 items-center justify-center border border-stone-100/15 text-stone-100/70 transition-all hover:border-gold-500 hover:text-gold-500"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="mb-6 font-sans text-[10px] font-semibold tracking-[0.3em] uppercase text-gold-500">
            Navegación
          </h3>
          <ul className="space-y-3 text-sm text-stone-100/70">
            <li>
              <Link to="/" className="hover:text-gold-500">
                Inicio
              </Link>
            </li>
            <li>
              <Link to="/areas" className="hover:text-gold-500">
                Áreas de Práctica
              </Link>
            </li>
            <li>
              <Link to="/trayectoria" className="hover:text-gold-500">
                Socios
              </Link>
            </li>
            <li>
              <Link to="/contacto" className="hover:text-gold-500">
                Contacto
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-6 font-sans text-[10px] font-semibold tracking-[0.3em] uppercase text-gold-500">
            Contacto
          </h3>
          <ul className="space-y-4 text-sm text-stone-100/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" />
              <span>
                Antequera 1026 casi Tte. Fariña
                <br />
                Asunción, Paraguay
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" />
              <a href="tel:+595994471947" className="hover:text-gold-500">
                +595 994 471 947
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" />
              <a href="mailto:contacto@estudiolibertad.com.py" className="hover:text-gold-500">
                contacto@estudiolibertad.com.py
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-100/10">
        <div className="container-elegant flex flex-col items-center justify-between gap-4 py-6 md:flex-row">
          <p className="text-[10px] tracking-[0.2em] uppercase text-stone-100/40">
            © {new Date().getFullYear()} Estudio Libertad E.A.E.S. · Consultores y Abogados
          </p>
          <p className="text-[10px] tracking-[0.2em] uppercase text-stone-100/40">
            Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}
